import { useFavoriteStore, useLeadStore, usePipedriveStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import ILead from "../interfaces/ILead";

const useLeadDelete = (): (lead: ILead) => Promise<void> => {
    const leadStore = useLeadStore();
    const pipedriveStore = usePipedriveStore();
    const favoriteStore = useFavoriteStore();

    return async (lead: ILead): Promise<void> => {
        try {
            if (lead.activityId)
                await pipedriveStore.deleteActivity(lead.activityId);

            await leadStore.deleteLead(lead.id);
            favoriteStore.removeFavoriteLead(lead.id);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLeadDelete;
